import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_base/_auth/settings/team/")({
  component: () => <Navigate to="/settings/team" replace />,
})
